module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/tv-1-ce302b7aefca84b2c49416566d11f012.svg";